module.exports = __webpack_public_path__ + "img/kiss-fm-au.5c568aa5.png";